import React from 'react';
import { Row } from 'react-bootstrap';

import StrapiText from '../../text/strapi-markdown-text-snippet';

import { FullWidthContentType } from '../../../models/strapi/full_width_content';

import * as styles from '../strapi-full-width-content.module.scss';

interface Props {
    data: FullWidthContentType;
    overlay?: boolean;
}

const TextOnImage = ({ data, overlay }: Props) => {
    overlay = overlay !== undefined ? overlay : true;
    const bannerStyle =
        data.textOnImageMobileVariant === 'textUnderneath'
            ? styles.mobileTextUnderneath
            : styles.mobileTextOverlay;
    return (
        <Row className='g-0'>
            <div className={`${bannerStyle} ${styles.bannerContainer}`}>
                {data.image && data.image.image ? (
                    <img src={data.image.image.url} alt={data.image.alt} />
                ) : null}
                <div className={styles[data.textOnImagePosition + 'ImgText']}>
                    {data.text &&
                        data.text.text &&
                        data.text.text.map((content, i) => <StrapiText data={content} key={i} />)}
                </div>
                {overlay && data.textOnImageMobileVariant !== 'textUnderneath' ? (
                    <div className={styles.imageOverlay}></div>
                ) : null}
            </div>
        </Row>
    );
};

export default TextOnImage;
